import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../services/user.service';
import { getUserFromSnapshot } from '../../utils/user.util';
import { User } from '../../models/user.model';

@Injectable({ providedIn: 'root' })
export class AdminStore {
  private userService = inject(UserService);

  readonly student = signal<User | null>(null);

  async setStudent(studentId: string): Promise<void> {
    try {
      const snapshot = await firstValueFrom(this.userService.getUser(studentId));
      this.student.set(getUserFromSnapshot(snapshot));
    } catch {
      this.student.set(null);
    }
  }

  clearStudent(): void {
    this.student.set(null);
  }
}
